module.exports = __webpack_public_path__ + "media/src/images/progress/dentals_3-9aee6686e139db35c6a974f01226a1dc.jpg";